import { useMemo } from "react";
import SelectDropdown, {
  SelectFilterOption,
} from "@/components/common/dropdown/SelectDropdown";

interface SpendDropdownProps {
  selected: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
  options?: Array<{ key: string; label: string; value: string }>;
}

const SpendDropdown = ({
  selected,
  onChange,
  className,
  disabled,
  options,
}: SpendDropdownProps) => {
  // Use provided options or fallback to default spend options
  const spendOptions: SelectFilterOption<string>[] = useMemo(
    () =>
      options || [
        { key: "spends", label: "Spends", value: "spends" },
        { key: "ads", label: "Ads", value: "ads" },
      ],
    [options],
  );

  // Get the default spend option (first option)
  const defaultSpend = useMemo(() => spendOptions[0]?.value || "", [spendOptions]);

  // Use defaultSpend if selected is empty
  const currentSelected = selected || defaultSpend;

  return (
    <SelectDropdown
      options={spendOptions}
      selected={currentSelected}
      onChange={onChange}
      className={className}
      disabled={disabled}
      placeholder="Select"
      dropdownAlign="end"
    />
  );
};

export default SpendDropdown;
